import { getClient } from "../client";

export async function getEditorials(preview, start = 0, end = 6) {
  try {
    const data = await getClient(preview).fetch(
      `*[_type == "editorial"] | order(_createdAt desc) {
        "key": _id, 
        ...,
      }[$start...$end]`,
      { start: start, end: end }
    );
    return data;
  } catch (err) {
    throw new Error(`[getAllEditorials] Failed to fetch all editorials`);
  }
}
